import type { Ability } from '@core/abilities-types';
import {
  createEntityCollectionStore,
  getEntityCollectionActions,
  pipeState,
} from '@core/ngrx-legacy';
import type { Role } from '@core/roles-types';

import type { RolePosition } from '../roles.types';
import { EntityStoreKey } from '../roles.types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<Role>()(
  EntityStoreKey.roles,
  {
    customActions: adapter => {
      const actions = getEntityCollectionActions(adapter, ({ id }) => id!);

      return {
        fetchRolesByAbility: (state, payload: { scope: Ability }) => adapter.markAsPending(state),
        fetchRolesByAbilitySuccess: actions.fetchCollectionSuccess,
        fetchRolesByAbilityFailed: actions.fetchCollectionFailed,
        deleteRole: (state, payload: { id: number; newRoleId: number }) =>
          adapter.markAsPending(state),
        deleteRoleSuccess: actions.removeOnePessimisticSuccess,
        deleteRoleFailed: actions.removeOnePessimisticFailed,
        duplicateRole: (state, payload: { id: number; correlationId: string }) =>
          adapter.markAsPending(state),
        duplicateRoleSuccess: actions.createOnePessimisticSuccess,
        duplicateRoleFailed: actions.createOnePessimisticFailed,
        saveRoleAbilities: (
          state,
          payload: {
            id: number;
            abilities: Partial<Record<Ability, boolean>>;
          },
        ) => adapter.markAsPending(state),
        saveRoleAbilitiesSuccess: actions.updateOnePessimisticSuccess,
        saveRoleAbilitiesFailed: actions.updateOnePessimisticFailed,
        updatePositions: (state, payload: { positions: RolePosition[] }) =>
          adapter.markAsPending(state),
        updatePositionsSuccess: (state, payload: Role[]) =>
          pipeState(
            state,
            next => adapter.updateMany(next, payload),
            next => adapter.markAsLoaded(next),
          ),
        updatePositionsFailed: actions.updateOnePessimisticFailed,
      };
    },
  },
);

export {
  actions as RoleActions,
  selectors as RoleSelectors,
  reducer as RoleReducer,
  namespace as RoleNamespace,
};
